<template>
  <div class="px-4 py-4 bg-white flex justify-between">
    <a href="#" class="hover:text-yellow-600" @click.prevent="toggleSidebar">
      <MenuIcon class="h-6 w-6" aria-hidden="true" />
    </a>
    <div class="ml-4 flex items-center md:ml-6">
      <!-- Announcement -->
      <Menu as="div" class="relative">
        <div>
          <MenuButton
            class="
              p-1
              bg-gray-100
              rounded-full
              flex
              mx-1
              items-center
              text-gray-500
              hover:text-gray-600
              focus:outline-none
              divide-y divide-gray-100
            "
          >
            <span class="sr-only">Open options</span>
            <SpeakerphoneIcon class="h-6 w-6" aria-hidden="true" />
            <sup class="font-semibold text-xs">{{ announcement.all }}</sup>
          </MenuButton>
        </div>

        <transition
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <MenuItems
            class="
              z-20
              origin-top-right
              absolute
              right-0
              mt-2
              w-72
              px-2
              py-1
              rounded-md
              shadow-lg
              bg-white
              ring-1 ring-black ring-opacity-5
              focus:outline-none
            "
          >
            <div class="py-1">
              <MenuItem
                v-if="hornList.length > 0 && announcement && announcement.first"
                as="div"
                v-slot="{ active }"
                @click="
                  $router.push({
                    name: 'announcement.detail',
                    params: { announcementId: announcement.first.id },
                  })
                "
                class="cursor-pointer"
              >
                <div
                  :class="[
                    active
                      ? 'bg-gray-100 px-1 py-2 text-gray-900'
                      : 'text-gray-700 px-1 py-2',
                    'block px-1 py-2 text-sm',
                  ]"
                >
                  <div class="flex w-full justify-around items-center">
                    <div class="flex-1">{{ announcement.first.title }}</div>
                    <div class="flex-1 text-right">
                      <small
                        class="
                          font-semibold
                          bg-red-600
                          text-white
                          p-1
                          rounded-lg
                        "
                      >
                        {{ $t("message.new") }}
                      </small>
                    </div>
                  </div>
                  <small class="text-gray-500">
                    {{
                      dateformat(
                        announcement.first.created_at,
                        "dddd, mmmm dS, yyyy, h:MM:ss TT"
                      )
                    }}
                  </small>
                </div>
              </MenuItem>
            </div>
            <div class="py-1 text-center">
              <MenuItem v-slot="{ active }">
                <router-link
                  :to="{ name: 'announcement.list' }"
                  class="bg-indigo-600 rounded text-white block py-3"
                >
                  <SpeakerphoneIcon
                    class="inline-block h-5 w-5 mr-1"
                    aria-hidden="true"
                  />
                  <strong>{{ $t("message.read_all_announcement") }}</strong>
                </router-link>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>
      <!-- End Announcement -->

      <Menu as="div" class="ml-3 relative">
        <div>
          <MenuButton
            class="max-w-xs bg-white flex items-center text-sm rounded-full"
          >
            <TranslateIcon class="h-5 w-5" aria-hidden="true" />
          </MenuButton>
          <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <MenuItems
              class="
                origin-top-right
                absolute
                z-20
                right-0
                mt-2
                w-48
                rounded-md
                shadow-lg
                py-1
                bg-white
                ring-1 ring-black ring-opacity-5
                focus:outline-none
              "
            >
              <MenuItem>
                <div
                  class="
                    w-full
                    flex
                    items-center
                    px-2
                    text-sm text-gray-700
                    hover:bg-gray-100
                  "
                  @click="handleChange('en')"
                >
                <img src="@Images/logo/United-Kingdom.png" class="w-11" />
                  <span class="ml-2"> English </span>
                </div>
              </MenuItem>
              <MenuItem>
                <div
                  class="
                    w-full
                    flex
                    items-center
                    px-2
                    text-sm text-gray-700
                    hover:bg-gray-100
                  "
                  @click="handleChange('mm')"
                >
                  <img src="@Images/logo/Myanmar.png" class="w-11" />
                  <span class="ml-2"> Myanmar </span>
                </div>
              </MenuItem>
              <MenuItem>
                <div
                  class="
                    w-full
                    flex
                    items-center
                    px-2
                    text-sm text-gray-700
                    hover:bg-gray-100
                  "
                  @click="handleChange('zh')"
                >
                  <img src="@Images/logo/China.png" class="w-11" />
                  <span class="ml-2"> China </span>
                </div>
              </MenuItem>
            </MenuItems>
          </transition>
        </div>
      </Menu>

      <!-- Profile dropdown -->
      <Menu as="div" class="ml-3 relative">
        <div>
          <MenuButton
            class="max-w-xs bg-white flex items-center text-sm rounded-full"
          >
            <span class="sr-only">Open user menu</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                clip-rule="evenodd"
              />
            </svg>
          </MenuButton>
        </div>
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <MenuItems
            class="
              origin-top-right
              absolute
              z-20
              right-0
              mt-2
              w-48
              rounded-md
              shadow-lg
              py-1
              bg-white
              ring-1 ring-black ring-opacity-5
              focus:outline-none
            "
          >
            <MenuItem>
              <span
                class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                {{ user.name }}
              </span>
            </MenuItem>
            <MenuItem>
              <span
                @click="logout"
                class="
                  block
                  px-4
                  py-2
                  text-sm text-gray-700
                  hover:bg-gray-100
                  cursor-pointer
                "
              >
                Logout
              </span>
            </MenuItem>
          </MenuItems>
        </transition>
      </Menu>
    </div>
  </div>
</template>

<script>
import Api from "Resources/util/api";
import dateformat from "dateformat";
import helper from "Resources/util/helper.js";

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";

import {
  BellIcon,
  MenuIcon,
  ChevronDownIcon,
  TranslateIcon,
  SpeakerphoneIcon,
  LibraryIcon,
  TruckIcon,
  TicketIcon,
  InboxInIcon,
} from "@heroicons/vue/outline";

export default {
  components: {
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    MenuIcon,
    BellIcon,
    ChevronDownIcon,
    TranslateIcon,
    SpeakerphoneIcon,
    LibraryIcon,
    TruckIcon,
    TicketIcon,
    InboxInIcon,
  },

  data() {
    return {
      user: this.$store.state.auth.user,
      hashids: this.$store.state.auth.hashids,
      locale: "mm",
      dateformat,
      hornList: [],
      announcement: {
        all: 0,
        first: {},
      },
      denyList: [],
      pickup: {
        all: 0,
        first: {},
      },
      ticket: {
        all: 0,
        za: 0,
        fcs: 0,
      },
      feedbackList: [],
      label: {
        feedback: 0,
      },
      merchantList: [],
    };
  },
  mounted() {
    this.locale = localStorage.getItem("locale")
      ? localStorage.getItem("locale")
      : "mm";
    if (this.locale) {
      this.setLocale(this.locale);
    }
    // this.pullMerchant();
    // this.pullAnnouncement();
    // this.pullPickupDeny();
    // this.pullTicketFromZa();
    // this.pullTicketCount();
  },

  methods: {
    handleChange(key) {
      this.setLocale(key);
      this.locale = key;
    },

    setLocale(locale) {
      localStorage.setItem("locale", locale);
      this.$emit("localeChange", locale);
      this.emitter.emit("localeChange", locale);

      //EventBus.$emit("localeChange", locale);
      this.$i18n.locale = locale;
      this.$store.dispatch("cache/setLocale", locale);
    },

    logout() {
      this.$store.dispatch("auth/logout");
      // EventBus.$emit("logout");
    },

    toggleSidebar() {
      let ele = document.getElementById("sidebar");

      ele.classList.toggle("minimize");

      this.emitter.emit(
        "toggleSidebar",
        ele.classList.contains("minimize") ? "close" : "open"
      );
    },

    pullAnnouncement() {
      Api.puller("/api/announcement/nav/noti")
        .then((response) => {
          this.hornList = response.data.data;
          this.announcement.all = response.data.total;
          this.announcement.first = response.data.data[0];
        })
        .catch(helper.flashErrorMessage);
    },

    pullPickupDeny() {
      Api.puller("/api/pickup-request/deny/nav/pickup-noti")
        .then((response) => {
          this.denyList = response.data.noti;
          this.pickup.all = response.data.count;
          this.pickup.first = response.data.noti[0];
        })
        .catch((error) => window.toastr.error(error));
    },

    pullTicketCount() {
      Api.puller("/api/supportTicket/ticket-count").then((response) => {
        this.ticket.fcs = response.data;
        this.totalTicket();
      });
    },

    pullTicketFromZa() {
      Api.puller("/api/ticket-to-za/noti-count/complete").then((response) => {
        this.ticket.za = response.data.from_za;
      });
    },

    totalTicket() {
      this.ticket.all = this.ticket.fcs + this.ticket.za;
    },

    pullMerchant() {
      Api.puller("/api/merchant")
        .then((response) => {
          this.merchantList = response.data.data;
          this.pullFeedbackCount();
        })
        .catch((error) => window.toastr(error));
    },

    pullFeedbackCount() {
      Api.puller("/api/feedback/count")
        .then((response) => {
          if (response.data) {
            this.label.feedback = response.data.data.length;
            this.feedbackList = response.data.data;
          }
        })
        .catch((error) => window.toastr.error(error));
    },
  },
};
</script>